import utils from 'utils';

import {useLabel} from '@/hooks/export';
import {UiCheckbox} from '@components/ui/typo/UiCheckbox.tsx';

export const DetailHead = (props: {
    mode: 'product' | 'order',
    item: apiProductDetail | apiOrderDetail,
    loading: boolean,

    onReadyForCollectUpdate: (value: boolean) => void,
}) => {
    const label = useLabel();

    return <div className={cmpClass + (props.loading ? ' ' + cmpClass + '--loading' : '')}>
        {
            (props.mode === 'order' || props.mode === 'product') ?
                <div
                    className={classMap.statusBar}
                    style={{borderTopColor: props.item.statusColor}}
                >
                    <span
                        style={{background: props.item.statusColor}}
                    >
                        {props.item.statusText}
                    </span>
                </div> : <></>
        }
        <div className={classMap.title}>
            {
                props.mode === 'order' ?
                    <>
                        <div className={classMap.titleMain}>
                            <div className={classMap.titleOrder}>
                                <i className={'iconfa-invoice'}></i>
                                <span>{(props.item as apiOrderDetail).orderNum}</span>
                            </div>
                            <div className={classMap.titleAccount}>
                                <span>{(props.item as apiOrderDetail).accountName}</span>
                            </div>
                            {
                                (props.item as apiOrderDetail).customerName ?
                                    <>
                                        <span>/</span>
                                        <div className={classMap.titleCustomer}>
                                            <span>{'' + (props.item as apiOrderDetail).customerName + ''}</span>
                                        </div>
                                    </> :
                                    <></>
                            }
                        </div>
                        <div className={classMap.titleCreatedBy}>
                            <div className={'ready-for-collect__checkbox' + ((props.item as apiOrderDetail).readyForCollect ? ' checked' : '')}>
                                <UiCheckbox
                                    onChange={(checked) => props.onReadyForCollectUpdate(checked)}
                                    checked={(props.item as apiOrderDetail).readyForCollect}
                                    disabled={props.loading}
                                />
                            </div>
                            {
                                (props.item as apiOrderDetail).createdBy ?
                                    <>
                                        <span>{label.createdBy}: </span>
                                        <span>
                                            {
                                                (props.item as apiOrderDetail).createdBy.firstName +
                                                ' ' +
                                                (props.item as apiOrderDetail).createdBy.lastName
                                            }
                                        </span>
                                    </> : <></>
                            }
                        </div>
                    </> : <></>
            }
            {
                props.mode === 'product' ?
                    <div className={classMap.titleMain}>
                        <div className={classMap.titleOrder}>
                            <i className={'iconfa-gear'}></i>
                            <span>{(props.item as apiProductDetail).name}</span>
                        </div>
                    </div>: <></>
            }
        </div>
        {
            props.mode === 'order' && (props.item as apiOrderDetail).note ?
                <div className={classMap.note}>
                    <div className={classMap.noteContent}>
                        <span><i className={'iconfa-note'}></i>{' : '}</span>
                        <span>{(props.item as apiOrderDetail).note}</span>
                    </div>
                </div> : <></>
        }
    </div>;
};

const cmpClass = 'detail-head';
const classMap = utils.generateClassMap(cmpClass, {
    note: 'note',
    noteContent: 'note-content',
    statusBar: 'status-bar',
    title: 'title',
    titleMain: 'title-main',
    titleOrder: 'title-order',
    titleAccount: 'title-account',
    titleCustomer: 'title-customer',
    titleCreatedBy: 'title-created-by',
});
